// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2j139","title":"BackImages_title__3Rr5a","images":"BackImages_images__IKRe8"};